import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography, useTheme } from "@mui/material";
import Papa from 'papaparse';
import Header from "../../component/header/Header";
import { useState } from "react";
import { tokens } from "../../theme";

const ImportScreen = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [csvData, setCsvData] = useState([]);
    // const [csvData2, setCsvData2] = useState([]);
    const [jsonData, setJsonData] = useState([]);
    const [page, pageChange] = useState(0);
    const [rowPerPage, rowPerPageChange] = useState(10);

    const [name, setName] = useState("");
    const [classroom, setClassroom] = useState("");

    const csvUploadFn = (event) => {
        const file = event.target.files[0];
        const fileType = file.name.split('.').pop().toLowerCase();
        if (fileType !== 'csv') {
            alert('Please upload a CSV file.');
            return;
        }
        Papa.parse(file, {
            complete: (result) => {
                setCsvData(result.data);
                console.log(result.data)
            },
            header: true,
        });
    };

    const csvUploadFn2 = (event) => {
        const file = event.target.files[0];
        const fileType = file.name.split('.').pop().toLowerCase();
        if (fileType !== 'csv') {
            alert('Please upload a CSV file.');
            return;
        }
        Papa.parse(file, {
            complete: (result) => {
                // setCsvData2(result.data);
                console.log(result.data)
            },
            header: true,
        });
    };

    const conversionFn = () => {
        const res = JSON.stringify(csvData, null, 2);
        setJsonData(res);
    };

    const handleChangePage = (event, newPage) => {
        pageChange(newPage);
    };

    const handleRowsPerpage = (event) => {
        rowPerPageChange(+event.target.value);
        pageChange(0);
    };

    const setImportData = () => {
        try {
            fetch('http://localhost:8000/api/importStudent', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body:
                    JSON.stringify(csvData.filter(page => page.Class === "F5").map(val => ({
                        Student_Name: val.Student_Name,
                        Guardian_Name: val.Guardian_Name,
                        Phone_No: val.Phone_No,
                        Class: val.Class,
                        Group: val.Group,
                        Package_Amount: val.Package_Amount,
                        Status: val.Status,
                        Bahasa_Melayu: val.Bahasa_Melayu,
                        Bahasa_Inggeris: val.Bahasa_Inggeris,
                        Sains: val.Sains,
                        Matematik: val.Matematik,
                        Sejarah: val.Sejarah,
                        Add_Math: val.Add_Math,
                        Akaun: val.Akaun,
                        Biologi: val.Biologi,
                        Kimia: val.Kimia,
                        Fizik: val.Fizik,
                        Mengaji: val.Mengaji,
                        Fardu_Ain: val.Fardu_Ain,
                        OTO_Bahasa_Melayu: val.OTO_Bahasa_Melayu,
                        OTO_Bahasa_Inggeris: val.OTO_Bahasa_Inggeris,
                        OTO_Sains: val.OTO_Sains,
                        OTO_Matematik: val.OTO_Matematik,
                        OTO_Sejarah: val.OTO_Sejarah,
                        OTO_Add_Math: val.OTO_Add_Math,
                        OTO_Akaun: val.OTO_Akaun,
                        OTO_Biologi: val.OTO_Biologi,
                        OTO_Kimia: val.OTO_Kimia,
                        OTO_Fizik: val.OTO_Fizik,
                        OTO_Mengaji: val.OTO_Mengaji,
                        OTO_Fardu_Ain: val.OTO_Fardu_Ain
                    })))
                // JSON.stringify(csvData.concat(csvData2))
            }).then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);
                }).catch((error) => {
                    console.log(error);
                });
        }
        catch (error) {
            console.log(error);
        }
    }

    const setExportData = () => {
        try {
            fetch('http://localhost:8000/api/importStudent', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body:
                    JSON.stringify(csvData.filter(page => page.Class === "F4").map(val => ({ Student_Name: val.Student_Name, Email: "", Bahasa_Melayu: "", Bahasa_Inggeris: "", Sains: "", Matematik: "" })))
                // JSON.stringify(csvData.concat(csvData2))
            }).then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);
                }).catch((error) => {
                    console.log(error);
                });
        }
        catch (error) {
            console.log(error);
        }
    }

    // ----- Table Column ----- //
    const columns = [
        { id: 'Student_Name', name: 'Student Name' },
        { id: 'Guardian_Name', name: 'Guardian Name' },
        { id: 'Phone_No', name: 'Phone Number' },
        { id: 'Class', name: 'Class' },
        { id: 'Group', name: 'Group' },
        { id: 'Package_Amount', name: 'Package Amount' },
        { id: 'Status', name: 'Status' }
    ];

    const AddStudent = () => {
        try {
            fetch(`http://localhost:8000/api/addNewStudent/${classroom}`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body:
                    JSON.stringify({
                        name: name
                    })
                // JSON.stringify(csvData.concat(csvData2))
            }).then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);
                }).catch((error) => {
                    console.log(error);
                });
        }
        catch (error) {
            console.log(error);
        }

    };

    return (
        <Box>
            <Header title={"Import CSV File"} />
            <Paper sx={{ width: '100%', padding: "20px", backgroundColor: colors.primary[999] }}>
                <Box>
                    <Box>
                        <h1>CSV to JSON Converter</h1>
                        <input type="file"
                            onChange={csvUploadFn}
                            accept=".csv" />
                        <input type="file"
                            onChange={csvUploadFn2}
                            accept=".csv" />
                        <button className="button"
                            onClick={conversionFn}>
                            Convert to JSON
                        </button>
                        <button className="button"
                            onClick={setImportData}>
                            Import
                        </button>
                    </Box>
                    <Box>
                        {csvData.length > 0 && (
                            <Box>
                                <h2>CSV Data</h2>
                                {/* <Table>
                                    <TableHead>
                                        <TableRow>
                                            {Object.keys(csvData[0]).map(
                                                (header, index) => (
                                                    <TableCell key={index}>
                                                        {header}
                                                    </TableCell>
                                                ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {csvData.map((row, rowIndex) => (
                                            <TableRow key={rowIndex}>
                                                {Object.values(row).map(
                                                    (cell, cellIndex) => (
                                                        <TableCell key={cellIndex}>
                                                            {cell}
                                                        </TableCell>
                                                    ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table> */}


                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <TableCell key={column.id} style={{ backgroundColor: colors.orange[200] }} sx={{ fontWeight: "bold", fontSize: "14px" }}>
                                                        {column.name}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {csvData && csvData.slice(page * rowPerPage, (page + 1) * rowPerPage).map((row, index) => (
                                                <TableRow hover key={index} sx={{ backgroundColor: colors.primary[999] }}>
                                                    {columns && columns.map((column, index) => {
                                                        let value = row[column.id];
                                                        return (
                                                            <TableCell sx={{ maxWidth: 250 }} key={index}>
                                                                {value}
                                                            </TableCell>
                                                        )
                                                    })}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    page={page}
                                    count={csvData.length}
                                    rowsPerPage={rowPerPage}
                                    component="div"
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleRowsPerpage}>
                                </TablePagination>
                            </Box>
                        )}
                        {jsonData && (
                            <div className="data-container">
                                <h2>JSON Data</h2>
                                {/* <pre>{jsonData}</pre> */}
                            </div>
                        )}
                        <pre>{JSON.stringify(csvData, null, 2)}</pre>
                    </Box>
                </Box>
                <Typography>Import</Typography>
                <Typography>
                    add Student
                </Typography>
                <TextField
                    id="name"
                    name="name"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <TextField
                    id="classromm"
                    name="classromm"
                    placeholder="Classroom"
                    value={classroom}
                    onChange={(e) => setClassroom(e.target.value)}
                />
                <Button onClick={() => AddStudent()}>Add</Button>
            </Paper>
        </Box>
    )
}

export default ImportScreen;